import { fork, put, select, take, takeEvery } from "redux-saga/effects";

import { RECEIVE } from "redux/modules/event/constants";
import { eventId as getEventId } from "redux/modules/event/selectors";
import { userId as getUserId } from "redux/modules/user/selectors";
import { createPusherChannel } from "App/Data/sagas";
import { SEVERITY } from "ui-kit/Alert/constants";
import { actions } from "ui-kit/Snackbar/model";
import { initInductionFormSaga } from "./inductionFormSaga";

function* watchGlobalPusherEvents(eventId, userId) {
  const channel = createPusherChannel({
    channelId: `event-${eventId}-user-${userId}`,
    eventTypes: ["send-email"],
    withEventTypes: true
  });

  yield takeEvery(channel, function*({ data }) {
    if (data?.message) {
      yield put(
        actions.show({
          message: data.message || "Email sent successfully",
          severity: SEVERITY.SUCCESS,
          autoHideDuration: 2000
        })
      );
    }
  });
}

export function* initSaga() {
  // Wait for the event to be loaded
  yield take(RECEIVE);
  const eventId = yield select(getEventId);
  const userId = yield select(getUserId);
  if (eventId) {
    yield fork(watchGlobalPusherEvents, eventId, userId);
    yield fork(initInductionFormSaga);
  }
}
